import {
  getMtxxWebGidValue,
  getPcAbCodeFromCookie,
  getPcGidFromCookie,
  getUrlParam,
  getUserType,
  handleMergeAbinfo,
} from '.';
import { Product } from '@meitu/subscribe-core';
import * as native from './native';
import { getDefaultStore } from 'jotai';
import {
  getClientId,
  getDeviceType,
  getEquityValue,
  getIncomeSource,
  getIncomeSourceValue,
  getOperaSystem,
  getOs,
} from './vip';
import { APP_KEY, APP_VERSION } from '@/constants';
import { UserInfo, VipInfo } from '@/services/user/index.d';
import {
  meidouTotalAtom,
  identificationAtom,
  curProductAtom,
  userInfoAtom,
  vipInfoAtom,
  rebateCodeAtom,
  curTabAtom,
  inviterUidAtom,
} from '@/store';
import { getAbInfo } from './abtest';
import { TabType } from '@/constants/subscription';

const store = getDefaultStore();

export const getTrackSubscribeDataParams = async () => {
  let channel = getUrlParam('channel') || window.sessionStorage.getItem('channel') || '';
  const entrance = getUrlParam('entrance') || '';
  const source = getUrlParam('source') || '';
  const vip_type = getUrlParam('vip_type') || '';
  const module_id = getUrlParam('module_id') || '';
  const matrix_channel = getUrlParam('matrix_channel') || '';
  const template_id = getUrlParam('template_id') || '';
  const gid = (await native.getServerGid()) || '';
  const isSdk = getUrlParam('is_sdk') || '';
  const companyKey = getUrlParam('company_key') || '';
  const operateSource = getUrlParam('operate_source') || '';
  const logo_id = getUrlParam('logo_id') || '';
  const oid = getUrlParam('oid') || '';
  const origin_func = getUrlParam('origin_func') || '';
  const user_source = getUrlParam('user_source') || '';
  const uid = window.localStorage.getItem('uid');
  const identification = store.get(identificationAtom);
  const is_collaborative_mode = getUrlParam('is_collaborative_mode') || '';
  const mtxx_web_gid = getMtxxWebGidValue();

  const curProduct = store.get(curProductAtom);
  const userInfo = store.get(userInfoAtom);
  const vipInfo = store.get(vipInfoAtom);
  const curTab = store.get(curTabAtom);

  let abInfo = getAbInfo();
  abInfo = JSON.stringify(abInfo);

  // 透传权益相关，web订阅通过URL透传
  const first_source = getUrlParam('first_source');
  const second_source = getUrlParam('second_source') || '';
  const third_source = getUrlParam('third_source');
  const entrance_type = getUrlParam('entrance_type');
  const ID = getUrlParam('ID');
  const touch_type = getUrlParam('touch_type') || '';
  const virtual_coin_appid = getUrlParam('virtual_coin_appid') || '';
  const gg_client_id = getUrlParam('gg_client_id') || '';
  const utm_info = getUrlParam('utm_info') || '';
  const deviceType = await getDeviceType();
  const inviterUid = store.get(inviterUidAtom);

  try {
    // 修复：如果用户手动修改channel导致无法正常解码的时候，就直接上报原始值
    channel = decodeURIComponent(channel);
  } catch (e) {}

  const meidouTotal = store.get(meidouTotalAtom);

  // 透传到订单接口的自定义字段数据
  const big_data: any = {
    gid,
    device_id: localStorage.getItem('GID'),
    channel,
    income_source: getIncomeSourceValue(),
    country_code: curProduct.countryCode,
    cashier_ind: 1, // 标记是从收银台下单
    ab_info: abInfo,
    is_sdk: isSdk,
    company_key: companyKey,
    operate_source: operateSource,
    user_type: getUserType(),
    residual_meidou: meidouTotal,
  };

  if (getIncomeSource() !== 'MTXX-WEB') {
    const appVersion = await native.getVersion();
    // 桌面端透传权益相关字段
    let statisticsData = await native.getStatisticsData();
    statisticsData =
      (typeof statisticsData === 'string' ? JSON.parse(statisticsData) : statisticsData) || {};
    Object.keys(statisticsData).forEach((key) => {
      big_data[key] = statisticsData[key] || '';
    });

    // 如果web透传权益的话，需要覆盖上面的权益协议内容
    if (source) {
      big_data.source = source;
    }
    if (first_source) {
      big_data.first_source = first_source;
    }
    if (second_source) {
      big_data.second_source = decodeURIComponent(second_source);
    }
    if (third_source) {
      big_data.third_source = third_source;
    }
    if (entrance_type) {
      big_data.entrance_type = entrance_type;
    }
    if (ID) {
      big_data.ID = ID;
    }

    big_data.entrance = entrance;
    big_data.app_version = appVersion || '';
    big_data.client_id = getClientId() || '';
    big_data.mac_addr = localStorage.getItem('GID') || '';
  } else {
    const first_url = getUrlParam('first_url') || window.sessionStorage.getItem('first_url') || '';
    big_data.first_url = decodeURIComponent(first_url);
    big_data.entrance = entrance;
    big_data.source = source || 'other';
    big_data.second_source = decodeURIComponent(second_source || '');
    if (third_source) big_data.third_source = decodeURIComponent(third_source || '');
    big_data.vip_type = vip_type;
    big_data.module_id = module_id;
    big_data.app_key = APP_KEY;
    big_data.matrix_channel = matrix_channel;
    big_data.template_id = template_id;
    big_data.oid = oid;
    big_data.uid = uid;
    big_data.origin_func = origin_func;
    big_data.user_source = user_source;
    // 触发类型(1:会员主页	 2:素材ID触发的订阅弹窗  3:配方直接触发的订阅弹窗  4:会员功能直接触发的订阅弹窗)
    big_data.touch_type = touch_type || 4;
    big_data.order_type = curProduct?.productType || 4;
    big_data.identification = identification;
    big_data.is_collaborative_mode = is_collaborative_mode;
    big_data.inviter = inviterUid;
    // roboneo场景

    if (virtual_coin_appid) {
      big_data.virtual_coin_appid = virtual_coin_appid;
      big_data.virtual_coin_appid_lv2 = virtual_coin_appid;
    }

    if (getEquityValue(vipInfo)) {
      big_data.equity = getEquityValue(vipInfo);
    }

    if (logo_id) {
      big_data.logo_id = logo_id;
    }

    // 从PC端外跳进入的鞋带参数
    const pcGid = getPcGidFromCookie();
    const pcAbCode = getPcAbCodeFromCookie();
    if (pcGid) {
      big_data.pc_gid = pcGid;
    }
    if (pcAbCode) {
      big_data.ab_code = pcAbCode;
    }
    if (mtxx_web_gid) {
      big_data.mtxx_web_gid = mtxx_web_gid;
    }
    if (gg_client_id) {
      big_data.gg_client_id = gg_client_id;
    }
    if (utm_info) {
      big_data.utm_info = utm_info;
    }
  }

  const data = {
    baseData: JSON.stringify({
      device_type: deviceType,
      oper_system: getOperaSystem(),
      open_params: {
        rebate_info: {
          // 邀请码，只有购买会员商品才参与分佣
          rebate_code: curTab === TabType.SUB ? store.get(rebateCodeAtom) : '',
        },
      },
    }),
    businessData: encodeURIComponent(JSON.stringify({})),
    bigData: encodeURIComponent(JSON.stringify(big_data)),
  };

  return data;
};
